import React from "react";
import styled from "styled-components";
import TitleSection from "../components/TitleSection/TitleSection";
import SubTitleSection from "../components/SubTitleSection/SubTitleSection";
import HospitalityUnit from "../components/Dining/HospitalityUnit";
import DiningCarousel from "../components/Restaurants/DiningCarousel";
import { t } from "i18next";

const Dining = () => {

  return (
    <MainDiv>
      <DiningCarousel />
      <container-div>
        <TitleSection title={t("dining.title")} />
        <SubTitleSection
          subTitleAs={"h2"}
          subTitle={t("dining.dining.header-title")}
          id={t("dining.restaurantsAnchor")}
        />
        <HospitalityUnit
          key={t("dining.dining.etc.name")}
          name={t("dining.dining.etc.name")}
          imgSrc={t("dining.dining.etc.imgSrc")}
          imgAlt={t("dining.dining.etc.imgAlt")}
          logoSrc={t("dining.dining.etc.logoSrc")}
          logoAlt={t("dining.dining.etc.logoAlt")}
          title={t("dining.dining.etc.title")}
          text={t("dining.dining.etc.text")}
          link={t("dining.dining.etc.link")}
          buttons={t("dining.dining.etc.buttons", {
            returnObjects: true,
          })}
          imageSide="right"
        />
        <HospitalityUnit
          key={t("dining.dining.theRail.name")}
          name={t("dining.dining.theRail.name")}
          imgSrc={t("dining.dining.theRail.imgSrc")}
          imgAlt={t("dining.dining.theRail.imgAlt")}
          logoSrc={t("dining.dining.theRail.logoSrc")}
          logoAlt={t("dining.dining.theRail.logoAlt")}
          title={t("dining.dining.theRail.title")}
          text={t("dining.dining.theRail.text")}
          link={t("dining.dining.theRail.link")}
          logoLink={t("dining.dining.theRail.logoLink")}
          buttons={t("dining.dining.theRail.buttons", {
            returnObjects: true,
          })}
          imageSide="left"
        />
      </container-div>
    </MainDiv>
  );
};

const MainDiv = styled.div`
  width: 100%;
`;

export default Dining;
